export function getUniqueArrayItems<T>(array: T[]): T[] {
  return Array.from(new Set(array));
}
